
import { useHistory } from "react-router-dom";
import { isRNWebView } from "../utils/isRNWebView";

export const useNavigateToFeedbackDetails = () => {
    const history = useHistory()
    return (feedbackId) => {
        if (!feedbackId) return
        const url = `/dashboard/feedback/details/${feedbackId}`
        if (isRNWebView()) {
            history.push(url)
        }
        else {
            window.open(url, '_blank');
        }
    }

}